import { originType, userType } from '@atlassiansox/analytics-web-client/analytics-web-types';
import AnalyticsWebClient from '@atlassiansox/analytics-web-client/client';

import { getConfig } from '../../config';

const product = 'teamworkGraph';
const subproduct = 'dtac';
let analyticsClient: AnalyticsWebClient | undefined;

const getIdentityEnv = (env: string): 'dev' | 'staging' | 'prod' => {
	switch (env) {
		case 'production':
			return 'prod';
		case 'staging':
			return 'staging';
		case 'development':
		case 'local':
		default:
			return 'dev';
	}
};

const getGasApiHost = (env: ReturnType<typeof getConfig>['env']): string => {
	switch (env) {
		case 'production':
			return `${window.location.host}/gateway/api/gasv3/api/v1`;
		case 'staging':
		case 'development':
		case 'local':
		default:
			return 'team.stg.atlassian.com/gateway/api/gasv3/api/v1';
	}
};

export const initAnalyticsClient = (): AnalyticsWebClient => {
	if (analyticsClient) {
		return analyticsClient;
	}
	const { env, isLocalDev } = getConfig();

	analyticsClient = new AnalyticsWebClient(
		{
			env: getIdentityEnv(env),
			origin: originType.WEB,
			product,
			subproduct,
		},
		{
			apiHost: getGasApiHost(env),
			apiHostProtocol: isLocalDev ? 'http' : 'https', // We sometimes develop on local and emulate PROD
			disableCookiePersistence: true,
		},
	);
	return analyticsClient;
};

export const setAnalyticsUser = (accountId: string): void => {
	if (!accountId || !analyticsClient) {
		return;
	}
	try {
		analyticsClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, accountId);
	} catch {
		// Analytics must not prevent the user from signing in.
		console.warn('Unable to identify the analytics user');
	}
};
